import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import ManaIconsFormatted from "../decklists/ManaIconsFormatted";

export default function SideboardView({ cards }) {
   const theme = useTheme();

   return (
      <AnimatePresence>
         {cards &&
            _.orderBy(cards, ["CMC"], ["asc"]).map((row, i) => (
               <Box
                  layout
                  component={motion.div}
                  sx={{
                     position: "relative",
                     fontFamily: "GothamNarrow-Bold",
                     mb: 0.4,
                     fontSize: ".8rem",
                     lineHeight: "1rem",
                     color: theme.palette.text.white,
                     backgroundColor: "#1f1f1f",
                  }}
                  key={"sideboardViewer"}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ layout: { duration: 0.4 } }}
               >
                     <Stack direction='row' spacing={1} alignItems='center' justifyContent='space-between' width='100%'
                        sx={{
                           whiteSpace: "nowrap",
                           width: "100%",
                           overflow: "hidden",
                           paddingRight: ".4rem",
                        }}
                     >  
                        <Stack direction='row' spacing={1} width='100%' 
                           padding=".4rem .5rem .2rem .8rem"
                           maxWidth={240}
                           sx={{ maskImage: "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)", maskRepeat: "no-repeat" }}>
                           <Box sx={{ border: '2px solid #555', borderRadius: 10, backgroundColor: '#333', paddingTop: "2px", minWidth: 20, minHeight: 20, width: 20, height: 20, top: -2, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>{row.Quantity}</Box>
                           <Typography variant='body1' sx={{ fontSize: ".8rem" }}>{row.CardName}</Typography>
                        </Stack>
                     
                        <ManaIconsFormatted
                           iconWidth={15}
                           mana={row.ManaCost}
                        />
                     </Stack>
               </Box>
            ))}
      </AnimatePresence>
   );
}
